"use strict";

import EventEmitter from "events";
//@ts-ignore

import { BigNumber, ethers } from "ethers";
import "@ethersproject/shims";
import { fundWallet, pollTxStatus } from "../services/backendHelpers";

// import { version } from "./_version";

const logger = new ethers.utils.Logger("1");
/*
function getBlockTag(tag) {
    if (tag == null) { return "latest"; }
    if (tag === "earliest" || tag === "latest" || tag === "pending") {
        return tag;
    }
    return ethers.utils.hexValue(tag)
}
*/

const chain_mapping: any = {
    137: {
        transfer: '',
        swap: '',
    },
    1: {
        transfer: '',
        swap: '',
    },
    2022: {
        transfer: '',
        swap: '',
    },
    2021: {
        transfer: '',
        swap: '',
    },
    3: {
        transfer: '',
        swap: '',
    },
    4: {
        transfer: '',
        swap: '',
    },
    // 80001: {
    //     transfer: '',
    //     swap: '',
    // },

}



export const networkToChainId: Map<string, number> = new Map([
    ["mainnet", 1],
    ["rinkeby", 4],
    // ["mumbai", 80001],
    ["ropsten", 3],
    ["matic", 137],
    ["localhost", 31337],
    ["ronin", 2022],
    ["skymavis", 2021],
    ["cypress", 8217],
    ["baobab", 1001],
    ["bscMainnet", 56],
    ["bora", 77001],
  ]);

export const httpUrlMap = {
    
}

// for localhost use namasteapis.com
// for other use bora portel
let boraRPC = "https://public-node.api.boraportal.io/bora/mainnet";
if(window.location.hostname === "localhost"){
    boraRPC = "https://be.namasteapis.com/blockchain/v1/glip/proxy/?url=https://public-node.api.boraportal.io/bora/mainnet";
}


export const jsonRpcUrlMap:any = {
    1: ['https://eth-mainnet.g.alchemy.com/v2/GevvZGoMNfoTV2IMrNqG_JbzDRSZStF3'],
    3: ['https://ropsten.infura.io/v3/f9f9c829617b43248215db1314a0fbd9'],
    137: [
        'https://polygon-mainnet.g.alchemy.com/v2/_tn9X7pFnXwYXYi8Q33gQjRg_B3Dey_4'
    ],
    4: ['https://rinkeby.infura.io/v3/ad1540581ba746208c1d10b3192c177e'],
    // 80001: ['https://polygon-mumbai.g.alchemy.com/v2/IcFdYe3mleISObU-2kcTZ0Ljq6rQz_iZ'],
    2022: ['https://api.roninchain.com/rpc'],
    2021: ['https://testnet.skymavis.one/rpc'],
    //8217: ['https://public-node-api.klaytnapi.com/v1/cypress'],
    //1001: ['https://public-node-api.klaytnapi.com/v1/baobab'],
    56: ['https://bsc-dataseed.binance.org'],
    77001: [boraRPC],
    //77001: ['https://be.namasteapis.com/blockchain/v1/glip/proxy/?url=https://public-node.api.boraportal.io/bora/mainnet'],
    // 77001: ['http://127.0.0.1:4040/blockchain/v1/glip/proxy/?url=https://public-node.api.boraportal.io/bora/mainnet'],
    //77001: ['https://public-node.api.boraportal.io/bora/mainnet'],
};
  
export const wssUrlMap:any = {
    1: ['wss://eth-mainnet.g.alchemy.com/v2/GevvZGoMNfoTV2IMrNqG_JbzDRSZStF3'],
    137: [
        'wss://polygon-mainnet.g.alchemy.com/v2/_tn9X7pFnXwYXYi8Q33gQjRg_B3Dey_4'
    ],
    // 80001: [
    //     'wss://polygon-mumbai.g.alchemy.com/v2/IcFdYe3mleISObU-2kcTZ0Ljq6rQz_iZ',
        
    // ],
    // 8217: ['wss://public-node-api.klaytnapi.com/v1/cypress/ws'],
    // 1001: ['wss://public-node-api.klaytnapi.com/v1/baobab/ws'],
  };
  


export function createProvider(chain: string) {
    //@ts-ignore
    let providerUrl: string = jsonRpcUrlMap[networkToChainId.get(chain)] ? jsonRpcUrlMap[networkToChainId.get(chain)][0] : null;
    let chainId = networkToChainId.get(chain);
    if (chainId === 137) {
        const randomIndex = Math.floor(Math.random() * jsonRpcUrlMap[chainId].length);
        // console.log("randomIndex", randomIndex, jsonRpcUrlMap[chainId].length);
        providerUrl = jsonRpcUrlMap[chainId][randomIndex];
    }
    
    var privateKey: any = JSON.parse(localStorage.getItem('gw-user-info') || '{}').privateKey || '';
    // console.log('providerUrl', providerUrl);
    if(!providerUrl) {
        throw new Error('ChainId not supported');
    }
    const prov: ethers.providers.Provider = new ethers.providers.JsonRpcProvider(providerUrl);

    let signer:any;
    if(privateKey) {
       signer  = new ethers.Wallet(new Buffer(privateKey.substring(2, 66), 'hex'), prov);
    }

    const provider: any = new Eip1193(signer, prov);
    return {signer, provider, prov};
}



export class Eip1193 extends EventEmitter {
    readonly signer!: ethers.Signer;
    readonly provider!: ethers.providers.Provider | any;
    readonly _isProvider: boolean;

    constructor(signer: ethers.Signer, provider?: ethers.providers.Provider) {
        super();
        ethers.utils.defineReadOnly(this, "signer", signer);
        ethers.utils.defineReadOnly(this, "provider", provider || null);
        this._isProvider = true;
    }

    changeProvider(provider: ethers.providers.Provider){
        ethers.utils.defineReadOnly(this, "provider", provider || null);
    }

    request(request: { method: string, params?: Array<any> }): Promise<any> {
        return this.send(request.method, request.params || []);
    }


    async sendAsync(request: { method: string, params?: Array<any> }, callback: (error: any, response: any) => void): Promise<void> {
        await this.send(request.method, request.params);
        callback(null, { result: true });
    }

    async wallet_switchEthereumChain(chainId: string): Promise<any> {
        // console.log('wallet_switchEthereumChain', chainId);
        //chain id is a hex string
        const chainIdInt = parseInt(chainId, 16);
        
        const hexChainId = ethers.BigNumber.from(chainIdInt).toHexString();
        
        
        // Check if the input chainId is available in the jsonRpcUrlMap
        let newProvider;
        if (jsonRpcUrlMap[chainIdInt]) {
            newProvider = new ethers.providers.JsonRpcProvider(jsonRpcUrlMap[chainId][0]);
        }
        else{
            throw new Error('ChainId not supported');
        }
        
        
        await newProvider.ready;
        this.emit("chainChanged", hexChainId);
        let newSigner  = this.signer.connect(newProvider);
        
        // Update the provider
        ethers.utils.defineReadOnly(this, "provider", newProvider);
        ethers.utils.defineReadOnly(this, "signer", newSigner);
        return null;
    }
    
    async wallet_addEthereumChain(chainDetails: {
        chainId: string,
        chainName: string,
        nativeCurrency: {
            name: string,
            symbol: string,
            decimals: number,
        },
        rpcUrls: string[],
        blockExplorerUrls?: string[],
    }): Promise<any> {
        // Ensure the chainId is in the correct format (0x-prefixed, hexadecimal)
        const chainId = ethers.BigNumber.from(chainDetails.chainId).toHexString();
        // Check if the input chainId is available in the jsonRpcUrlMap
        // first convert chainId to number
        const chainIdInt = parseInt(chainId, 16);
        // console.log('chainIdInt', chainIdInt);
        let newProvider;
        if (!jsonRpcUrlMap[chainIdInt]) {
            
            newProvider = new ethers.providers.JsonRpcProvider(chainDetails.rpcUrls[0]);
        }
        else{
            newProvider = new ethers.providers.JsonRpcProvider(jsonRpcUrlMap[chainIdInt][0]);
        }
        await newProvider.ready;
        let newSigner = this.signer.connect(newProvider);
        this.emit("chainChanged", chainId);
        
        //jsonRpcUrlMap[parseInt(chainId)] = chainDetails.rpcUrls;
        //if (chainDetails.rpcUrls[0].startsWith('wss://')) {
         //   wssUrlMap[parseInt(chainId)] = chainDetails.rpcUrls;
        //}
        
        // Update the provider
        ethers.utils.defineReadOnly(this, "provider", newProvider);
        ethers.utils.defineReadOnly(this, "signer", newSigner);
        return null;
    }
    
    async send(method: string, params?: Array<any>): Promise<any> {
        function throwUnsupported(message: string): never {
            console.log('error', message);
            throw logger.throwError(message, ethers.utils.Logger.errors.UNSUPPORTED_OPERATION, {
                method: method,
                params: params
            });
        }

        let coerce = (value: any) => value;

        if (params === undefined) return;
        console.log('method', method, params);
        switch (method) {
            case "eth_gasPrice": {
                const result = await this.provider.getGasPrice();
                return result.toHexString();
            }
            case "eth_accounts": {
                const result = [];
                if (this.signer) {
                    const address = await this.signer.getAddress();
                    result.push(address);
                }
                return result;
            }
            case "eth_requestAccounts": {
                const result = [];
                if (this.signer) {
                    const address = await this.signer.getAddress();
                    result.push(address);
                }
                return result;
            }
            case "eth_blockNumber": {
                return await this.provider.getBlockNumber();
            }
            case "eth_chainId": {
                const result = await this.provider.getNetwork();
                return ethers.utils.hexValue(result.chainId);
            }
            case "eth_getBalance": {
                const result = await this.provider.getBalance(params[0], params[1]);
                return result.toHexString();
            }
            case "eth_getStorageAt": {
                return this.provider.getStorageAt(params[0], params[1], params[2]);
            }
            case "eth_getTransactionCount": {
                const result = await this.provider.getTransactionCount(params[0], params[1]);
                return ethers.utils.hexValue(result);
            }
            case "eth_getBlockTransactionCountByHash":
            case "eth_getBlockTransactionCountByNumber": {
                const result = await this.provider.getBlock(params[0]);
                return ethers.utils.hexValue(result.transactions.length);
            }
            case "eth_getCode": {
                const result = await this.provider.getCode(params[0], params[1]);
                return result;
            }
            case "eth_sendRawTransaction": {
                return await this.provider.sendTransaction(params[0]);
            }
            case "eth_call": {
                const req = ethers.providers.JsonRpcProvider.hexlifyTransaction(params[0], { from: true, gas: true });
                return await this.provider.call(req, params[1]);
            }
            case "estimateGas": {
                if (params[1] && params[1] !== "latest") {
                    throwUnsupported("estimateGas does not support blockTag");
                }

                const req = ethers.providers.JsonRpcProvider.hexlifyTransaction(params[0], { from: true, gas: true });
                const result = await this.provider.estimateGas(req);
                return result.toHexString();
            }

            // @TODO: Transform? No uncles?
            case "eth_getBlockByHash":
            case "eth_getBlockByNumber": {
                if (params[1]) {
                    return await this.provider.getBlockWithTransactions(params[0]);
                } else {
                    return await this.provider.getBlock(params[0]);
                }
            }
            case "eth_getTransactionByHash": {
                return await this.provider.getTransaction(params[0]);
            }
            case "eth_getTransactionReceipt": {
                return await this.provider.getTransactionReceipt(params[0]);
            }

            case "eth_sign": {
                if (!this.signer) {
                    return throwUnsupported("eth_sign requires an account");
                }

                const address = await this.signer.getAddress();
                if (address !== ethers.utils.getAddress(params[0])) {
                    logger.throwArgumentError("account mismatch or account not found", "params[0]", params[0]);
                }

                return this.signer.signMessage(ethers.utils.arrayify(params[1]));
            }

            case "eth_signTypedData_v4": {
                if (!this.signer) {
                    return throwUnsupported("eth_signTypedData requires an account");
                }

                const address = await this.signer.getAddress();
                if (address !== ethers.utils.getAddress(params[0])) {
                    logger.throwArgumentError("account mismatch or account not found", "params[0]", params[0]);
                }
               let typedData: any = JSON.parse(params[1]);
               console.log('typedData', typedData)

               delete typedData.types.EIP712Domain

               console.log('signer', this.signer)
               console.log('typedData domain', typedData.domain)
               console.log('typedData types', typedData.types)
               console.log('typedData message', typedData.message)

               
               //@ts-ignore
                let signed = this.signer._signTypedData(typedData.domain, typedData.types, typedData.message);
                console.log('signed', signed);
                let result = await signed
                console.log('result', result);
                return signed
            }

            case "eth_sendTransaction": {

                if (!this.signer) {
                    return throwUnsupported("eth_sendTransaction requires an account");
                }

                const req = ethers.providers.JsonRpcProvider.hexlifyTransaction(params[0], { from: true, gas: true });

                const gasPrice = (await this.provider.getGasPrice());

                delete params[0].gasPrice;
                delete params[0].maxFeePerGas;
                delete params[0].maxPriorityFeePerGas;

                const addr = await this.signer.getAddress();

                const reqToGetGas = {
                    ...req,
                    from: addr,
                    value: req.value || "0x0",
                }

                let gasLimit = await this.provider.send("eth_estimateGas", [
                    reqToGetGas,
                    "latest",
                    // override,
                ]);
                gasLimit = ethers.BigNumber.from(gasLimit);
                req.gasLimit = gasLimit;
                req.gasPrice = gasPrice;

                const gasAmount = gasLimit.mul(gasPrice);

                // Check balance of the address using the provider
                const balance = await this.provider.getBalance(await this.signer.getAddress());

                console.log(req);
                console.log(JSON.stringify(req));
                console.log(JSON.stringify(reqToGetGas));


                console.log("Required : ",
                            gasAmount.add(BigNumber.from(req.value || "0x0")).toString(), "Available : ", balance.toString());
                if (balance.lt(gasAmount.add(BigNumber.from(req.value || "0x0")))) {

                    // If balance is less than gasAmount, then call fundWallet function
                    // @todo : user should know if the wallet is fundable or not, without having to sent a fundwallet actual request
                    const testFundingAPICall: any = await fundWallet((await this.provider.getNetwork()).chainId, gasAmount.toString(), true);
                    // If response is fine then we can show the option to the user. Maybe the user's wallet is 
                    // Already funded enough times, or in total

                    if (testFundingAPICall.success === true) {
                        const resp: any = await fundWallet((await this.provider.getNetwork()).chainId, gasAmount.toString(), false);
                        // Get the Glip txId from resp.data and poll for the tx status
                        const txId = resp.data.txId;
                        const success = await pollTxStatus(txId);
                        if (!success) {
                            throw new Error('Fund transaction failed or did not finish in 30 seconds!');
                        }
                        // wait for 2 seconds
                        await new Promise((resolve) => setTimeout(resolve, 1000));
                    }

                }

                // Send transaction using signer
                console.log("Sending transaction", this.signer.provider);
                const tx = await this.signer.sendTransaction({
                    ...req
                });

                return tx.hash;
            }

            case "eth_getUncleCountByBlockHash":
            case "eth_getUncleCountByBlockNumber":
                {
                    coerce = ethers.utils.hexValue;
                    break;
                }

            case "eth_getTransactionByBlockHashAndIndex":
            case "eth_getTransactionByBlockNumberAndIndex":
            case "eth_getUncleByBlockHashAndIndex":
            case "eth_getUncleByBlockNumberAndIndex":
            case "eth_newFilter":
            case "eth_newBlockFilter":
            case "eth_newPendingTransactionFilter":
            case "eth_uninstallFilter":
            case "eth_getFilterChanges":
            case "eth_getFilterLogs":
            case "eth_getLogs":
            case "wallet_addEthereumChain":
                {
                    console.log("params", params);
                    return await this.wallet_addEthereumChain(params[0]);
                }

            case "wallet_switchEthereumChain": {
                return await this.wallet_switchEthereumChain(params[0]);
            }
        }

        // If our provider supports send, maybe it can do a better job?
        if ((<any>(this.provider)).send) {
            const result = await (<any>(this.provider)).send(method, params);
            return coerce(result);
        }

        return throwUnsupported(`unsupported method: ${method}`);
    }

}
